import React from "react"

export default class extends React.Component {
  render() {
    const { data } = this.props
    return (
      <>
        {(() => {
          switch (process.env.NODE_ENV) {
            case "development":
              return <pre>{JSON.stringify(data, 0, 2)}</pre>
            default:
              return ""
          }
        })()}
      </>
    )
  }
}
